import {
  Tag as ChakraTag,
  TagRootProps as ChakraTagRootProps,
} from "@chakra-ui/react";
import { TagColorScheme, TagSize } from "./Tag.props";
import { getSizeProps, getColorProps } from "./utils";

export type TagProps = ChakraTagRootProps & {
  size?: TagSize;
  colorPalette?: TagColorScheme;
};

export default function Tag(props: TagProps): JSX.Element {
  const { size, colorPalette, children, ...rest } = props;

  const sizeProps = size ? getSizeProps(size as TagSize) : {};
  const colorProps = colorPalette
    ? getColorProps(colorPalette as TagColorScheme)
    : {};

  return (
    <ChakraTag.Root
      fontWeight={600}
      borderRadius="sm"
      {...sizeProps}
      {...colorProps}
      colorPalette={colorPalette}
      {...rest}
    >
      {children}
    </ChakraTag.Root>
  );
}
